export enum EditableDataTableColumnType {
  NONE,
  TEXTBOX,
  SELECT,
  CUSTOM1,
  DATEPICKER,
  DEFAULT_ACTIONS,
  AUTOCOMPLETE,
  CHECKBOX,
}
